// src/features/cart/api/removeFromCart.js
import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useMutation } from 'react-query';
import { useNotificationStore } from 'stores/notifications';

export const removeFromCart = (productId) => {
  return axios.delete(`/cart/remove/${productId}`);
};

export const useRemoveFromCart = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: removeFromCart,
    onSuccess: () => {
      queryClient.invalidateQueries('cart');
      addNotification({
        type: 'success',
        title: 'Item removed',
      });
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Remove failed',
        message: 'Could not remove item from cart. Please try again.',
      });
    },
    ...config,
  });
};
